import React from 'react';

const UserContext = React.createContext({user: null});

export default UserContext;


// WEBPACK FOOTER //
// ./src/components/UserContext.js